/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Tooltip, TooltipProps, Fade } from '@mui/material';

interface TableTooltipProps extends TooltipProps {
    spacing?: string;
}

export const TableTooltip = (props: TableTooltipProps) => {
    const useStyles = makeStyles((theme: Theme) => ({
        tooltip: {
            padding: theme.spacing(1, 1),
            fontSize: 12,
            margin: props.spacing ? `${props.spacing} !important` : `${theme.spacing(1)} !important`,
        },
    }));
    const classes = useStyles();

    return <Tooltip arrow classes={classes} TransitionComponent={Fade} TransitionProps={{ timeout: 500 }} {...props} />;
};
